// Components==============
import { useTranslate } from './useTranslate';
// =========================

export function useSliderValue(value: number) {
  const translate = useTranslate();

  const getSliderValues = () => {
    if (value >= 1 && value <= 8) return `reflection.drag.value-${value}`;

    return 'general.terms.drag-me';
  };

  return translate(getSliderValues());
}
